import React from 'react'

const SeltzerRedTemplate = (props) => {
    console.log(props)
    let seltzerBevs = props.seltzerMenu.items
    let redWine = props.redWine.items
    console.log(seltzerBevs)
    return (
        <div className="seltzer-red-page">
            Seltzer Red Page goes here
        </div>
    )
}
export default SeltzerRedTemplate